import { useQuery } from '@tanstack/react-query'
import { QueryKeys } from '@/core/models/enum'
import { getSensorMetadataConfigurations } from '@/api/apiService'
import { Sensor } from '../models'

export function useSensorConfigurations(sensor: Sensor | null) {
    const sensorDbKey = sensor?.sensorDbKey ?? ''
    return useQuery({
        queryKey: [QueryKeys.Configurations, sensorDbKey],
        enabled: !!sensorDbKey,
        queryFn: () => getSensorMetadataConfigurations(sensorDbKey),
    })
}
